<div class="scoring-rules-card">
  <button
    class="scoring-header"
    (click)="toggleExpand()"
    [attr.aria-expanded]="isExpanded"
  >
    <div class="header-content">
      <span class="header-icon"
        ><lucide-icon name="bar-chart-3" [size]="18"></lucide-icon
      ></span>
      <span class="header-title">ReBall Scoring Rules</span>
    </div>
    <span class="expand-icon" [class.expanded]="isExpanded">›</span>
  </button>

  <div class="scoring-content" [class.expanded]="isExpanded">
    <div class="rules-section">
      <h4 class="section-subtitle">How Points Are Calculated</h4>
      <div class="rules-grid">
        <div
          *ngFor="let rule of pointRules"
          class="rule-item"
          [class]="rule.type"
        >
          <span class="rule-icon"
            ><lucide-icon [name]="rule.icon" [size]="16"></lucide-icon
          ></span>
          <span class="rule-description">{{ rule.description }}</span>
          <span class="rule-points" [class]="rule.type"
            >{{ rule.points }} RB</span
          >
        </div>
      </div>
    </div>

    <div class="examples-section">
      <h4 class="section-subtitle">Examples</h4>
      <div class="examples-list">
        <div
          *ngFor="let example of examples"
          class="example-item"
          [class]="example.type"
        >
          <div class="example-header">
            <span class="example-scenario">{{ example.scenario }}</span>
            <span class="example-sets">{{ example.sets }}</span>
          </div>
          <div class="example-calculation">{{ example.calculation }}</div>
          <div class="example-total" [class]="example.type">
            {{ example.total }}
          </div>
        </div>
      </div>
    </div>

    <div class="formula-note">
      <span class="note-icon"
        ><lucide-icon name="info" [size]="16"></lucide-icon
      ></span>
      <span class="note-text"
        >Formula: 15 + (Sets Won × 20) - (Sets Lost × 5) + Victory Bonus</span
      >
    </div>
  </div>
</div>
